import React from 'react';
import { Popover } from 'antd';
import { EditFilled } from '@ant-design/icons'
import { SwatchesPicker } from 'react-color';


const ColoredItem = ({ label, color, onUpdateColor, variant='text', size='small'}) => {
    return (
        <Popover content={<SwatchesPicker color={color} onChangeComplete={onUpdateColor} />}>
            <EditFilled fontSize={size} style={{ color }} />
        </Popover>
    )
};

export default ColoredItem;
